import { Typography } from "ui-kit/Typography";

export const ClinicInfoOverlay: React.FC = () => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
      <Typography variant="body1">Snittkostnad skada</Typography>
      <Typography variant="body2">
        Snittkostnaden är snittet av kostnader registrerade hos Lassie för
        kliniken under de senaste två åren.
      </Typography>
      <Typography variant="body2">
        Ditt aktuella pris hos veterinären kan variera beroende på de
        individuella förutsättningar som gäller för ditt besök och ditt djur.
      </Typography>
    </div>
  );
};
